export default {
  name: 'inventaire-indicateurs',
  props: {
    indicateurs: { type: Array, default: () => [] },
  },
}
